// Configuración centralizada de i18n
export const I18N_CONFIG = {
  defaultLanguage: 'es',
  supportedLanguages: ['es', 'en'],
  fallbackLanguage: 'es'
};

export const LANGUAGE_NAMES = {
  es: 'Español',
  en: 'English', 
  fr: 'Français'
};